<template>
    <a-modal class="modal-box" v-model="visible" :title="$t('submission.email_history_detail.email_content' /*邮件内容*/)" width="900px" @cancel="visible = false" :footer="null">
        <div style="overflow-x: auto">
            <table>
                <tr>
                    <th>{{ $t('submission.email_history_detail.email' /*邮箱*/) }}</th>
                    <td>{{ info?.target }}</td>
                </tr>
                <tr>
                    <th>{{ $t('submission.email_history_detail.sender' /*发送者*/) }}</th>
                    <td>{{ info?.real_name }}</td>
                </tr>
                <tr>
                    <th>{{ $t('submission.email_history_detail.send_status' /*发送状态*/) }}</th>
                    <td>
                        <a-badge v-if="info?.status == 1" :text="info?.status_desc" status="success" />
                        <a-badge v-else-if="info?.status == 3" :text="info?.status_desc" status="blue" />
                        <a-badge v-else-if="info?.status == 2" :text="info?.status_desc" status="error" />
                        <a-badge v-else-if="info?.status == 0" :text="info?.status_desc" status="error" />
                    </td>
                </tr>
                <tr>
                    <th>{{ $t('submission.email_history_detail.send_time' /*发送时间*/) }}</th>
                    <td>{{ info?.send_time }}</td>
                </tr>
                <tr>
                    <th>{{ $t('submission.email_history_detail.theme' /*主题*/) }}</th>
                    <td>{{ info?.theme }}</td>
                </tr>
                <tr>
                    <th>{{ $t('submission.email_history_detail.operator_send_status' /*运营商发送状态*/) }}</th>
                    <td>{{ info?.send_status_desc }}</td>
                </tr>
                <tr>
                    <th>{{ $t('submission.email_history_detail.send_return_value' /*发送返回值*/) }}</th>
                    <td>{{ info?.message_id }}</td>
                </tr>
            </table>
        </div>
        <div class="mt10" style="border: 5px solid #ddd; padding: 25px" v-html="info?.content"></div>
    </a-modal>
</template>

<script>
export default {
    name: 'EmailHisoryDetail',
    components: {},
    data() {
        return {
            visible: false,
            info: {}
        };
    },
    computed: {},
    methods: {
        show(email_id) {
            this.visible = true;
            this.getEmailDetails(email_id);
        },
        getEmailDetails(email_id) {
            this.$request.get({ url: 'getEmailDetails', data: { email_id } }).then(res => {
                this.info = res.data;
                this.info.content = this.info.content.replaceAll('<style', '<style scoped');
            });
        }
    },
    created() {},
    mounted() {}
};
</script>
<style lang="less" scoped>
table {
    border-collapse: collapse;
    width: 100%;
    border: 1px solid #e8e8e8;
    th {
        background-color: #f7f7f7;
        border-bottom: 1px solid #e8e8e8;
        width: 150px;
        padding: 10px 15px;
        text-align: center;
    }
    td {
        border-bottom: 1px solid #e8e8e8;
        padding: 10px 15px;
        vertical-align: middle;
        color: #666;
    }
}
</style>
